module.exports = __webpack_public_path__ + "static/media/plus.599a5c20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plus.svg
// module id = 121
// module chunks = 21